"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _immutabilityHelper = _interopRequireDefault(require("immutability-helper"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ImageSource = _interopRequireDefault(require("../ImageSource"));

var Images =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2["default"])(Images, _PureComponent);

  function Images() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, Images);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(Images)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      images: undefined
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onHover", function (_ref) {
      var targetIndex = _ref.targetIndex;
      return _this.setState({
        activeTarget: targetIndex
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onMove", function (_ref2) {
      var sourceIndex = _ref2.sourceIndex,
          targetIndex = _ref2.targetIndex;

      if (typeof targetIndex === 'undefined') {
        _this.setState({
          activeTarget: undefined
        });

        return;
      }

      _this.setState(function (_ref3) {
        var images = _ref3.images;
        return {
          activeTarget: undefined,
          images: (0, _immutabilityHelper["default"])(images, {
            $splice: [[sourceIndex, 1], [targetIndex, 0, images[sourceIndex]]]
          })
        };
      }, function () {
        var onChangePosition = _this.props.onChangePosition;

        var input = _this.state.images.map(function (_ref4, index) {
          var id = _ref4.id;
          return {
            id: id,
            position: index
          };
        });

        if (onChangePosition) onChangePosition(input);
      });
    });
    return _this;
  }

  (0, _createClass2["default"])(Images, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.images !== this.props.images) {
        this.setState({
          images: this.props.images
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          onDeactivate = _this$props.onDeactivate,
          onActivate = _this$props.onActivate,
          onClick = _this$props.onClick;
      var _this$state = this.state,
          images = _this$state.images,
          activeTarget = _this$state.activeTarget;
      return images.map(function (image, index) {
        return _react["default"].createElement(_ImageSource["default"], {
          isActive: index === activeTarget,
          key: image.id,
          index: index,
          image: image,
          onDrop: _this2.onMove,
          onHover: _this2.onHover,
          onDeactivate: onDeactivate,
          onActivate: onActivate,
          onClick: onClick
        });
      });
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      if (!state.images) return {
        images: props.images
      };
      return null;
    }
  }]);
  return Images;
}(_react.PureComponent);

exports["default"] = Images;
(0, _defineProperty2["default"])(Images, "propTypes", {
  onChangePosition: _propTypes["default"].func,
  onDeactivate: _propTypes["default"].func,
  onActivate: _propTypes["default"].func
});